var _defs, _ellipse, _ellipse2, _path, _path2, _path3, _line, _line2, _line3, _line4, _path4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _ellipse3, _path12, _line15, _line16, _line17, _path13, _path14, _path15, _polygon, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _ellipse4, _path40, _path41, _path42, _path43, _path44, _path45;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeRepairing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    xmlns: "http://www.w3.org/1999/xhtml"
  }, "*, ::after, ::before { box-sizing: border-box; }\nimg, svg { vertical-align: middle; }\n"), /*#__PURE__*/React.createElement("style", {
    xmlns: "http://www.w3.org/1999/xhtml"
  }, "*, body, html { -webkit-font-smoothing: antialiased; }\nimg, svg { max-width: 100%; }\n"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 454.88,
    cy: 622.23,
    rx: 221.76,
    ry: 36.61,
    fill: "#0071f2",
    "data-primary": "true"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 454.88,
    cy: 622.23,
    rx: 221.76,
    ry: 36.61,
    fill: "#fff",
    opacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M834.23,258.87,630,601.77H277.4l-126-85.12-5.14-3.46a60.88,60.88,0,0,1-19.88-22.31L121,480.57,38.45,321.73A58.44,58.44,0,0,1,52.79,250L121,192.83l30.38-25.42L312.9,32.26c18.55-13.75,38.69-6.08,38.69-6.08L576.8,111.24l20.33,7.67,98.52,37.22,7.69,2.9L813.93,200.8A40.12,40.12,0,0,1,834.23,258.87Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M834.23,258.87,630,601.77H277.4l-126-85.12-5.14-3.46a60.88,60.88,0,0,1-19.88-22.31L121,480.57,38.45,321.73A58.44,58.44,0,0,1,52.79,250L121,192.83l30.38-25.42L312.9,32.26c18.55-13.75,38.69-6.08,38.69-6.08L576.8,111.24l20.33,7.67,98.52,37.22,7.69,2.9L813.93,200.8A40.12,40.12,0,0,1,834.23,258.87Z",
    fill: "#fff",
    opacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M255.85,78.93h84.87",
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 451.04,
    y1: 398.39,
    x2: 452.32,
    y2: 599.65,
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 675.84,
    y1: 399.35,
    x2: 677.12,
    y2: 523.26,
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 732.12,
    y1: 171.04,
    x2: 733.4,
    y2: 429.25,
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 788.4,
    y1: 190.38,
    x2: 789.67,
    y2: 333.96,
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.42,167.41V516.65l-5.14-3.46a60.88,60.88,0,0,1-19.88-22.31L121,480.57V192.83Z",
    fill: "#ebebeb"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 195.2,
    y1: 131.84,
    x2: 352.23,
    y2: 130.25,
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 150.68,
    y1: 178.8,
    x2: 297.55,
    y2: 178.8,
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 152.28,
    y1: 228.05,
    x2: 299.15,
    y2: 228.05,
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 151.44,
    y1: 276.41,
    x2: 308.1,
    y2: 276.41,
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 151.44,
    y1: 326.29,
    x2: 308.1,
    y2: 326.29,
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 151.44,
    y1: 375.22,
    x2: 395.56,
    y2: 375.22,
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 151.44,
    y1: 425.1,
    x2: 395.56,
    y2: 425.1,
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 151.44,
    y1: 472.11,
    x2: 395.56,
    y2: 472.11,
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 151.44,
    y1: 521.99,
    x2: 395.56,
    y2: 521.99,
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 229.6,
    y1: 569.96,
    x2: 400.04,
    y2: 569.96,
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M327.36,356.94c4.22,20.25-3.27,20.67-3.27,20.67-5.43,1-2.88-7.68-2.88-7.68.64-8.95-1.28-8-1.28-8-13.75-7-8.95,55.64-8.95,55.64,1.28,27.18-2.88,25.26-2.88,25.26-9,.32-8-53.08-8-53.08.32-36.14-15.35-50.53-15.35-50.53-14.39-17.26-10.87-43.16-10.87-43.16l-.63-89.71-1-140.21L312.9,32.26a43.1,43.1,0,0,1,38.69-6.08l45.09,17,.19,178.75.11,98.88Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M420.57,637a19.34,19.34,0,0,1-18.4,13.39H351.81a19.32,19.32,0,0,1-18.7-14.44l-9.83-37.65c4.34,8.54,13.09,20.55,30.17,29.46a84.21,84.21,0,0,0,39.62,9.44Z",
    opacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M695.65,156.13v98.05H562.32V118.91h34.81l-20.33-7.67H433a21.62,21.62,0,0,0-21.63,21.63V381.24A21.62,21.62,0,0,0,433,402.87H681.71a21.63,21.63,0,0,0,21.63-21.63V159ZM554,395.19H440.7a21.62,21.62,0,0,1-21.63-21.62V262.49H554Zm0-141H419.07V140.54a21.63,21.63,0,0,1,21.63-21.63H554ZM695.65,373.57A21.62,21.62,0,0,1,674,395.19H562.32V262.49H695.65Z",
    fill: "#ebebeb"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M653.12,605.15h-.31l-387.37-4.8-.11-.05-112.07-61a66,66,0,0,1-24.86-23.71L22.76,341.41c-.11-.2-10.23-18.74,1.91-41.42l.09-.12L281.53,46c.12-.15,16.22-19.29,46.89-7.79L824,179.83c.15,0,13.18,4.6,19.56,17.82,4.81,10,4.69,22.16-.36,36.23Zm-387.42-5.8,386.81,4.79,189.8-370.66c4.93-13.75,5.07-25.68.38-35.4-6.2-12.84-18.83-17.25-19-17.3L328.11,39.13c-30-11.25-45.69,7.32-45.84,7.51L25.51,300.53c-11.82,22.15-2,40.2-1.88,40.38L129.26,515.1a64.88,64.88,0,0,0,24.48,23.35Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M399.46,332a4.57,4.57,0,0,1-3.25,4.27l-82,24.66-2.87-10.34-3.42-12.3,82.45-23.06a3,3,0,0,1,2.54.46,15.41,15.41,0,0,1,5.43,7.84A25.56,25.56,0,0,1,399.46,332Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M399.46,332a4.57,4.57,0,0,1-3.25,4.27l-82,24.66-2.87-10.34,87-27.06h0A25.56,25.56,0,0,1,399.46,332Z",
    opacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M367.26,335.08l317.9,35.71a3.56,3.56,0,0,1,3.11,4.17h0a3.56,3.56,0,0,1-3.92,2.9l-334-38.94-33.57,10.87-1.28-4.48L397.64,322a16.64,16.64,0,0,1,.64,1.6,17.58,17.58,0,0,1,.64,2.55Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 311.04,
    cy: 349.65,
    rx: 7.07,
    ry: 11.75,
    transform: "translate(-82.23 96) rotate(-15.52)",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M396.87,221.88C335,231.78,294,217.34,273.26,206.36l-1-140.21L312.9,32.26a43.1,43.1,0,0,1,38.69-6.08l45.09,17Z",
    opacity: 0.2
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 506.36,
    y1: 399.33,
    x2: 507.64,
    y2: 600.59,
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 565.52,
    y1: 403.07,
    x2: 566.8,
    y2: 604.33,
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 618.6,
    y1: 398.39,
    x2: 619.88,
    y2: 599.65,
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M552.73,587.06l-2.24,24.3a23.62,23.62,0,0,0-9.28,2.24c-13.43,4.15-16.62-3.84-16.62-3.84L527.46,588Z",
    fill: "#f9b499"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M552.41,619.35a132.9,132.9,0,0,1-.41,18c-.59,5.41-1.51,6.33-1.51,6.33-10.55,2.87-22.07-5.44-22.07-5.44-3.47-1.32-14.44-1.36-24.25-1.09-9.17.25-17.32.77-17.32.77-13.57.89-17.47-7.59-18.26-15.25a38.54,38.54,0,0,1,.26-9.3,2.77,2.77,0,0,1,2.68-2.36l9.5-.22,43.56-1s3.19,8,16.62,3.84a23.62,23.62,0,0,1,9.28-2.24C554.32,611.68,552.41,619.35,552.41,619.35Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M506.12,633.71l-1.95,3.42c-9.17.25-17.32.77-17.32.77-13.57.89-17.47-7.59-18.26-15.25a38.54,38.54,0,0,1,.26-9.3,2.77,2.77,0,0,1,2.68-2.36l9.5-.22C482,616,486.58,626.3,506.12,633.71Z",
    opacity: 0.2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "617.64 553.48 630.75 577.78 648.34 559.24 640.98 541.33 617.64 553.48",
    fill: "#f9b499"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M552,637.33c-.59,5.41-1.51,6.33-1.51,6.33-10.55,2.87-22.07-5.44-22.07-5.44-6.71-2.56-41.57-.32-41.57-.32-13.57.89-17.47-7.59-18.26-15.25,4.2,4.84,13.05,11.72,29.14,11.09L523,633.1a35.87,35.87,0,0,1,13.75,3.2S539.55,638.09,552,637.33Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M668.66,575.9a32.16,32.16,0,0,1-2.27,5.78,27.72,27.72,0,0,1-3.28,5.08,18.22,18.22,0,0,0-3.58,13.41s.32,19.18-13.43,18.54l-14.6.75-10.34.53s-15.67-3.84-9.28-13.11c0,0,6.53-6.52,12.54-2.42l.25.18s3.55,4.06,5-2.28A14.38,14.38,0,0,0,630,598c-.49-5.89-1.63-27.39,7.18-34,0,0,6.54-8.11,17-2.08a25.78,25.78,0,0,1,3.44,2.4l9.71,7.55A3.81,3.81,0,0,1,668.66,575.9Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M668.66,575.9a32.74,32.74,0,0,1-2.26,5.78,28.3,28.3,0,0,1-3.29,5.08,18.22,18.22,0,0,0-3.58,13.41s.32,19.18-13.43,18.54L621.16,620s-15.67-3.84-9.28-13.11c0,0,6.53-6.52,12.54-2.42-3.83,1.84-10.24,5.73-5.82,9.46,0,0,3.43,2.91,9.78,1.21a18,18,0,0,0,12.47-12.5,28.65,28.65,0,0,0,1.09-7.21v-.69c0-10.55,2.24-15,8.32-20.78a15.94,15.94,0,0,0,3.91-12,25.78,25.78,0,0,1,3.44,2.4l9.7,7.55A3.8,3.8,0,0,1,668.66,575.9Z",
    opacity: 0.2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M668.66,575.9a32.16,32.16,0,0,1-2.27,5.78,27.72,27.72,0,0,1-3.28,5.08,18.22,18.22,0,0,0-3.58,13.41s.32,19.18-13.43,18.54l-14.6.75c5.33-1.48,14.88-5.06,16.81-12.15a9.54,9.54,0,0,0,.27-3.24c-.43-5.52-1.74-34.89,18.74-32.17A3.81,3.81,0,0,1,668.66,575.9Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M641.86,545.56l-3.22.24a16.29,16.29,0,0,0-8,2.8l-2.52,1.72L619,556.55a4.34,4.34,0,0,1-6.24-1.47l-30.88-55.41A23.4,23.4,0,0,1,579,489.58l-2.58-47.06a43.83,43.83,0,0,0-.69-5c-.88-4.07-1.87-1.71-1.87-1.71L561.17,555.54l-3.33,31.52c-3.39,7-21.5,5.23-30.05,4a5.29,5.29,0,0,1-4.51-5.19l-.64-116.61L522,359.7l101.36,7.67-1,46.1L621,473.87a31.27,31.27,0,0,0,2.25,12.3l21.87,54.16A3.81,3.81,0,0,1,641.86,545.56Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M621.43,479.83c-4.39,1.11-12.56,1.54-10.19-11.73l11.07-54.82s0,.06,0,.19L621,473.87A30.46,30.46,0,0,0,621.43,479.83Z",
    opacity: 0.2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M522,359.7V371s37.81,34.16,100.76,25l.6-28.67Z",
    opacity: 0.2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M628.13,550.32,619,556.55a4.34,4.34,0,0,1-6.24-1.47l-30.88-55.41A23.4,23.4,0,0,1,579,489.58l-2.58-47.06a43.83,43.83,0,0,0-.69-5c.21-1.44,5.67-39.43,5.58-57l6.3-1.29-5.76,74.18s-.31,25.26,10.88,45.41l10.9,17.28a94.78,94.78,0,0,0,11.93,15.2C620.25,536.19,626.37,543.56,628.13,550.32Z",
    opacity: 0.2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M561.17,555.54l-3.33,31.52c-3.39,7-21.5,5.23-30.05,4a5.29,5.29,0,0,1-4.51-5.19l-.64-116.61.41.38s9.85,50.95,9.85,51.59,3.52,27.18,3.52,27.18S539.08,571.13,561.17,555.54Z",
    opacity: 0.2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M441.13,328a210.31,210.31,0,0,0,45.4-30.69l22.07,20.46-54,24.3s-23,7.68-16.28,13.65a3.24,3.24,0,0,1,.65,4.12c-1.37,2.19-4.76,4.51-13.15,3,0,0-26.54-1.6-14.39-27.18,0,0-12.22,1.64-16.92-2.12a1.54,1.54,0,0,1,.79-2.7l14.88-2.13a43.92,43.92,0,0,1,5.72-.44Z",
    fill: "#f9b499"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M431.18,355.27c-11.7,0-22.9-5.34-23-5.41l.44-.9c.15.08,15.24,7.27,28.48,4.79l.19,1A33.41,33.41,0,0,1,431.18,355.27Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M486.53,297.35l-3.88,3.37s5.43,18.22,15.05,22l10.9-4.88Z",
    fill: "#f7a48b"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M638.66,340.19c3.6,8.94,6.48,15.35,6.48,15.35-13.28,13.51-44.08,21.11-60.52,24.35-6.53,1.28-10.79,1.87-10.79,1.87C529.7,385,522,359.7,522,359.7V336c1-27.18-1.28-26.86-1.28-26.86-4.16,6.71-12.15,8.63-12.15,8.63-4.7,1.61-9.57-1.35-13.87-5.81-5.39-5.56-9.89-13.46-12.13-17.72a3.51,3.51,0,0,1,1.24-4.6C499.75,279.62,526.5,250,526.5,250c9-11.83,19.19-12.15,19.19-12.15l31.5-6.8a66,66,0,0,1,55.92,27c5.73,7.76,9.47,11.3,11.49,12.87a2,2,0,0,1,.17,3,27,27,0,0,1-4.17,3.43,28.15,28.15,0,0,1-19.44,4.37c2.23,7,4.47,18.54,4.47,18.54C627.82,311.91,633.88,328.29,638.66,340.19Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M584.62,379.89c-6.53,1.28-10.79,1.87-10.79,1.87C529.7,385,522,359.7,522,359.7V336c1-27.18-1.28-26.86-1.28-26.86-4.16,6.71-12.15,8.63-12.15,8.63-4.7,1.61-9.57-1.35-13.87-5.81,9.2-4.29,31.52-17.85,38.81-50.79,0,0,7.35,12.15.64,45.41,0,0-2.44,22,5,40.62a42.29,42.29,0,0,0,23,23.26Z",
    opacity: 0.2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M533.22,259.29c5.44,15.5,5.21,33.86-3.84,48,.28-.47.9-1.57,1.16-2,.69-1.32,1.4-2.84,2-4.2,5.46-13.18,5-28.31.69-41.75Z",
    opacity: 0.2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M621.16,281.68c2.23,7,4.47,18.54,4.47,18.54,2.19,11.69,8.25,28.07,13,40-46.22.79-30.76-38.29-26.9-46.7a28.59,28.59,0,0,0,2.31-7.39c3.27-20.34-13.77-42.79-14-43.11a163.33,163.33,0,0,1,12.78,12.47c10.55,12.47,27.82,21.42,27.82,21.42l-.06.43A28.15,28.15,0,0,1,621.16,281.68Z",
    opacity: 0.2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M621.16,281.68c-.28-1,9.5,1.18,16.74-2.77l6.15,15.29a18.82,18.82,0,0,1-.95,16.08l-9.22,16.87a165.67,165.67,0,0,1-8.25-26.93S623.39,289.67,621.16,281.68Z",
    fill: "#f9b499"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M524,177.75s-8.32,54.68,14.39,53.4c0,0,25.26.64,30-45.08l-1.27-17.27Z",
    fill: "#f9b499"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M592.35,193.62a2.75,2.75,0,0,1-3.83,2.23l-2.35-1-29-12.71a28.36,28.36,0,0,0-10-2.37l-32-1.57a.69.69,0,0,1-.39-1.23l2.59-2.07a60.94,60.94,0,0,0,8.56-8.28c15.62-18.51,33.16-17.38,41.56-15.39a21.29,21.29,0,0,1,8.42,4.17C592.88,169.11,593.17,186.26,592.35,193.62Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M567.54,151.19s-27.92,8.27-37,27.65l16.67.89a28.68,28.68,0,0,1,4.3.51s10.07-23.73,22.29-26.54A16.62,16.62,0,0,0,567.54,151.19Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M588.52,195.85l-2.35-1c.36-6.68.33-25.7-10.22-39.45,16.93,13.75,17.22,30.9,16.4,38.26A2.75,2.75,0,0,1,588.52,195.85Z",
    fill: "#fff",
    opacity: 0.4
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M545.69,228.91v10.56s24.94,5.43,31.34-7.36V202.69l-9-2.23Z",
    fill: "#f9b499"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M545.69,237.87v-9l22.38-28.45,9,2.23v5.44s-1.92,3.2-7.36,4.16C569.67,212.29,557.52,229.87,545.69,237.87Z",
    fill: "#f7a48b"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M564.56,183.83s3,38.21-27.66,47.48h0a1.42,1.42,0,0,0,1.39,1.59c5.22.11,22.54-2.86,34.9-44Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 574.88,
    cy: 197.9,
    rx: 10.71,
    ry: 6.08,
    transform: "translate(235.77 702.53) rotate(-75.09)",
    fill: "#f9b499"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M450.08,531.74l-29.3,104.52-.21.72a19.34,19.34,0,0,1-18.4,13.39H351.81a19.32,19.32,0,0,1-18.7-14.44l-9.83-37.65L310.66,550S389.16,573.79,450.08,531.74Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M310.66,550S405,536.21,450.08,531.74C450.08,531.74,397.32,574,310.66,550Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M310.66,550S405,536.21,450.08,531.74C450.08,531.74,397.32,574,310.66,550Z",
    opacity: 0.2
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M434.73,553.48s-5.43,2.56-2.24,10.23a7.3,7.3,0,0,1,.63,1.19c1,2.29,2.51,7.77-1.2,15.49a21.64,21.64,0,0,0-1.85,6.15c-1.1,7.31-3.93,23.5-8.19,28.53a1.09,1.09,0,0,1-1.92-.68l-.81-29.29a8.09,8.09,0,0,0-1.91-5,24.94,24.94,0,0,1-5.53-15.69v0a10.44,10.44,0,0,0-.44-2.83,12.34,12.34,0,0,0-9.27-8.67s-27.09,7.58-66.09,2.18c0,0,12.44-3.82,39.56-2.12a16.16,16.16,0,0,0,5.09-.47c2.22-.57,7.05-1.27,17.33-1.25a16.59,16.59,0,0,0,6.3-1.22c8.65-3.52,33.12-13,37.58-9.3C441.77,540.69,445,546.77,434.73,553.48Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M431.92,580.39a21.64,21.64,0,0,0-1.85,6.15c-1.1,7.31-3.93,23.5-8.19,28.53a1.09,1.09,0,0,1-1.92-.68l-.81-29.29a8.09,8.09,0,0,0-1.91-5,24.94,24.94,0,0,1-5.53-15.69,29.59,29.59,0,0,0,21.41.5C434.12,567.19,435.63,572.67,431.92,580.39Z",
    opacity: 0.2
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M336.5,555.25s-19.44,12.62-4.41,32.45c0,0,26.86,34.85,53.4,3.83a147.24,147.24,0,0,0,21.86-36.09",
    fill: "none",
    stroke: "#ebebeb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeRepairing);
export default __webpack_public_path__ + "static/media/Home Repairing.1f7b485090a4be5f9eeefafd47ae915c.svg";
export { ForwardRef as ReactComponent };